import { CommandResponseMode } from "lib/deviceDrivers/sessionFramework/device/types";
import { FrameType, type ScpFrame } from "./types";

const DEVICE_ERROR_PATTERN = /^\(([A-F0-9]{2})\)$/;
const DEVICE_BUSY_ERROR_CODE = "14";

export function parseScpFrame(serializedPayload: string): ScpFrame {
  const raw = `${serializedPayload ?? ""}`.trim();

  if (raw === "^") {
    return { type: FrameType.ACK, raw };
  }

  const errorMatch = DEVICE_ERROR_PATTERN.exec(raw);
  if (errorMatch) {
    return { type: FrameType.ERROR, code: errorMatch[1], raw };
  }

  if (raw.startsWith("[") && raw.endsWith("]")) {
    const value = raw.slice(1, -1).trim();
    return { type: FrameType.BRACKET, value: value || null, raw };
  }

  return { type: FrameType.TEXT, value: raw, raw };
}

export function matchesResponseMode(
  responseMode: CommandResponseMode,
  frame: ScpFrame,
): boolean {
  switch (responseMode) {
    case CommandResponseMode.NONE:
      return false;
    case CommandResponseMode.ACK:
      return frame.type === FrameType.ACK;
    case CommandResponseMode.DATA:
      return frame.type === FrameType.BRACKET || frame.type === FrameType.TEXT;
    case CommandResponseMode.ACK_OR_DATA:
      return (
        frame.type === FrameType.ACK ||
        frame.type === FrameType.BRACKET ||
        frame.type === FrameType.TEXT
      );
    default:
      return false;
  }
}

export function isRetryableDeviceErrorCode(code: string): boolean {
  return code === DEVICE_BUSY_ERROR_CODE;
}
